export default {
    chapters: {},
    chapter: {},
    artists: []
};
